import { render } from "./FileUploadeForm.vue?vue&type=template&id=2bc982a5&scoped=true"
import script from "./FileUploadeForm.vue?vue&type=script&lang=js"
export * from "./FileUploadeForm.vue?vue&type=script&lang=js"

import "./FileUploadeForm.vue?vue&type=style&index=0&id=2bc982a5&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bc982a5"

export default script